'use strict';
/* created by lileilei 2017.12.17
 *输入框聚焦时去掉搜索图标和placeholder
 */
angular.module('formControlModule', []).
directive('formControl', ['$timeout', '$compile', 'globleParamsSet', function($timeout, $compile, globleParamsSet) {
    return {
        restrict: 'C',
        scope: false,
        link: function(scope, $elem, $attrs) {
            var placeholder;
            var watcher = globleParamsSet.domObserver($elem[0], { attribute: true, attributeOldValue: true }, function(e) {
                var $target = $(e[0].target);
                if($target.attr("placeholder")!==undefined){
                    placeholder = $target.attr("placeholder");
                    watcher.disconnect();
                }
            });
            $elem.bind({
                focus: function() {
                    if ($elem.prev('.iconfont.icon-fangdajing').length > 0) {
                        $elem.prev('.iconfont.icon-fangdajing').hide();
                    }
                    if ($elem.next(".iconfont.icon-fangdajing")) {
                        $elem.next(".iconfont.icon-fangdajing").hide();
                    }
                    $elem.attr('placeholder', '');
                },
                blur: function() {
                    if ($elem.prev('.iconfont.icon-fangdajing').length > 0) {
                        $elem.prev('.iconfont.icon-fangdajing').show();
                    }
                    if ($elem.next(".iconfont.icon-fangdajing")) {
                        $elem.next(".iconfont.icon-fangdajing").show();
                    }
                    $elem.attr('placeholder', placeholder);
                }
            });

        }
    };
}]);